import useModal from "@/@core/components/base-modal/hooks/useModal";
import router from "@/router";
import store from "@/store";
import {
  onMounted,
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  getCurrentInstance,
} from "@vue/composition-api";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import {
  pageIndex,
  templateType,
  showLayout,
  expireType,
} from "@/configs/privilege/code-template";

export default function useCodeTemplateModal(props) {
  const vm = getCurrentInstance().proxy;

  const { openModal, closeModal } = useModal();

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr();

  const modalType = reactive({
    choosePrivilege: false,
    selectImgae: false,
  });

  const onUploadBgImage = (image) => {
    props.formModal.backgroundImg.file = image.file;
    props.formModal.backgroundImg.url = image.url;
  };

  const onUploadLogoImage = (image) => {
    props.formModal.logoImg.file = image.file;
    props.formModal.logoImg.url = image.url;
  };

  const onUploadBg = (obj) => {
    vm.$emit("onUploadBg", obj);
  };

  const onUploadLogo = (obj) => {
    vm.$emit("onUploadLogo", obj);
  };

  const openChoosePrivilegeModal = () => {
    modalType.choosePrivilege = true;
    openModal();
  };

  const closeChoosePrivilegeModal = () => {
    closeModal();
    modalType.choosePrivilege = false;
  };

  const addLayout = (layout) => {
    switch (layout) {
      case showLayout.PRIVILEGE_NAME:
        props.formModal.isLayoutPrivilegeNameShow = true;
        break;
      case showLayout.PRIVILEGE_DESC:
        props.formModal.isLayoutDescShow = true;
        break;
      case showLayout.PRIVILEGE_REMARK:
        props.formModal.isLayoutRemarkShow = true;
      case showLayout.PRIVILEGE_TERM:
        props.formModal.isLayoutTermShow = true;
        break;
      case showLayout.PRIVILEGE_BG:
        props.formModal.isLayoutBgShow = true;
        break;
      case showLayout.PRIVILEGE_LOGO:
        props.formModal.isLayoutLogoShow = true;
        break;
    }
  };

  const editorQuill = computed(() => vm.$refs.myQuill.quill);
  const editQuillRemark = computed(() => vm.$refs.myQuillRemark.quill);

  const onFocus = (focusId) => {
    vm.$emit("onSelectEditor", focusId);
  };

  const onCheckEditorInputFocus = (editorSelectId) => {
    if (editorSelectId == "privilegeTermEditor") {
      editorQuill.value.focus();
    } else if (editorSelectId == "remarkTextEditer") {
      editQuillRemark.value.focus();
    } else if (editorSelectId == "expTextEditor") {
      let expDateInput = null;
      if (props.formModal.expireType == expireType.EXPIRE_DATE)
        expDateInput = document.getElementById("expireDate-date");
      else expDateInput = document.getElementById("redeemDate-date");
      expDateInput.click();
    } else {
      if (vm.$refs[`${editorSelectId}`]) vm.$refs[`${editorSelectId}`].focus();
    }
  };

  const customQuillOption = {
    theme: "snow",
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
      keyboard: {
        bindings: {
          "list autofill": {
            prefix: "",
          },
        },
      },
    },
  };

  const formatName = (value) => {
    return value.substr(0, 80);
  };

  watch(
    () => props.editorSelectId,
    () => {
      onCheckEditorInputFocus(props.editorSelectId);
    },
    { deep: true }
  );

  watch(
    props.formModal,
    () => {
      vm.$emit("onChange", props.formModal);
    },
    { deep: true }
  );

  return {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,

    openChoosePrivilegeModal,
    closeChoosePrivilegeModal,
    onUploadBgImage,
    onUploadLogoImage,

    onUploadBg,
    onUploadLogo,
    addLayout,
    onFocus,
    customQuillOption,
    formatName,

    pageIndex,
    templateType,
    showLayout,
    expireType,
  };
}
